export function eventTypes (state) {
	return state.eventTypes;
}
